"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = void 0;
var icons = exports.icons = {
  tick: 'https://petcdnstore.blob.core.windows.net/qt-assets/modernization/cba/Tick.png',
  cross: 'https://petcdnstore.blob.core.windows.net/qt-assets/modernization/cba/Close.png'
};